module.exports = __webpack_public_path__ + "img/护理-11.0371677d.png";